import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import Loader from "../../Loader";
import { useDispatch, useSelector } from "react-redux";
import { GetAllUsersName } from "../../redux/Actions/userStatusService";
import moment from "moment";

const StrategyPerformanceTable = ({ strategyObj }) => {
  const dispatch = useDispatch();
  const { userNames } = useSelector((state) => state.userStatus);
  const [strategy, setStrategy] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    dispatch(GetAllUsersName());
  }, [dispatch]);

  useEffect(() => {
    if (strategyObj && userNames) {
      const data = strategyObj.map((item, index) => {
        const { userId, totalPortfolio, totalPnL, totalReturns, createdAt } =
          item;
        const matchingUser = userNames?.find((user) => user.id == userId);
        const displayUserName = matchingUser ? matchingUser.name : userId;
        return [
          index + 1,
          displayUserName,
          totalPortfolio,
          totalPnL,
          totalReturns,
          createdAt,
        ];
      });

      setStrategy(data);
      setLoading(false);
    } else {
      setError("Error loading data. Please try again.");
      setLoading(false);
    }
  }, [strategyObj, userNames]);

  const columns = [
    {
      name: "#",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "25px" }}>{value}</div>;
        },
      },
    },
    {
      name: "Investors",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value}</div>;
        },
      },
    },
    {
      name: "Portfolio value in strategy",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value?.toFixed(2)}</div>;
        },
      },
    },
    {
      name: "Gain (Loss)",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value?.toFixed(2)}</div>;
        },
      },
    },
    {
      name: "Return %",
      options: {
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value?.toFixed(2)}%</div>;
        },
      },
    },
    {
      name: "Invested in strategy since",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return (
            <div style={{ marginLeft: "20px" }}>
              {" "}
              {moment(value)?.format("DD/MM/YYYY")}
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : error ? (
        <p>{error}</p>
      ) : (
        <div style={{ marginTop: "20px", width: "100%" }}>
          <MUIDataTable
            data={strategy}
            options={options}
            columns={columns}
            style={{
              width: "1000px",
            }}
          />
        </div>
      )}
    </>
  );
};

export default StrategyPerformanceTable;
